import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';
const PREFIX = 'LoadMoreButton';
const classes = {
  root: `${PREFIX}-root`
};
const Root = styled('div')(/* istanbul ignore next */({
  theme: {
    palette
  }
}) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    textAlign: 'center',
    '&::before, &::after': {
      content: "''",
      borderBottom: `1px solid ${palette.layout.line.divider}`,
      flexGrow: 1,
      transform: 'translateY(-50%)'
    }
  }
}));
export default function LoadMoreButton(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Root className={classes.root}><Button {...props} variant="tertiary" /></Root>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}